import styled from 'styled-components';
import dt from '../../../shared/theme';
import DropdownIndicator from '../../shared/dropdown-styles';

const Container = styled.form`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`;

const Label = styled.label`
  color: ${props => dt(props).theme.bodyColor};
  font-size: 16px;
  font-weight: 800;
  text-transform: uppercase;
  padding-top: 8px;
  width: 30%;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
`;

const InputText = styled.input`
  height: 40px !important;
  border-radius: 4px;
  border: 1px solid #E9EEF3;
  padding-left: 16px !important;
  font-size: 19px;
`;

const InputFile = styled.input`
  &.file {
    border: none !important;
    padding-left: 0 !important;
    padding-top: 10px !important;
  }
`;

const Textarea = styled.textarea`
  height: 220px;
  border-radius: 4px;
  border: 1px solid #E9EEF3;
  padding: 16px;
  font-size: 19px;
  resize: vertical;
`;

const Button = styled.button`
  padding: 0 24px;
  margin-top: 16px;
  margin-left: auto;
`;

const HelpBlock = styled.div`
  color: ${props => dt(props).theme.errorColor};
  font-size: 16px;
  font-weight: ${props => dt(props).theme.fontWeightMedium};
  text-transform: none;
`;

const SuccessMessage = styled.div`
  color: ${props => dt(props).theme.successColor};
  font-size: 19px;
  font-weight: ${props => dt(props).theme.fontWeightBold};
  text-transform: none;
  margin-bottom: 16px;
`;

const SectionTitle = styled.div`
  font-size: 20px;
  font-weight: ${props => dt(props).theme.fontWeightHeavy};
  margin-top: 24px;
  text-transform: uppercase;
`;

const SectionSeparator = styled.div`
  width: 100%;
  height: 0px;
  border: none;
  border-bottom: 1px solid ${props => dt(props).theme.primaryColor};
  margin: 8px 0 24px;
`;

const Separator = styled.div`
  width: 100%;
  height: 0px;
  border: none;
  border-bottom: 1px solid #D7DFE7;
  margin: 16px 0 !important;
`;

const selectorStyles = {
  container: provided => ({
    ...provided,
    fontSize: 18,
    fontWeight: 400,
    textTransform: 'none',
    width: '100%',
  }),
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? '#6f8aa1' : '#e4eaee',
    '&:hover': {
      borderColor: '#6f8aa1',
    },
    borderRadius: 4,
    outline: 'none',
    boxShadow: 'none',
    height: state.isMulti ? '' : 40,
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    height: state.isMulti ? '' : 40,
    paddingRight: 8,
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  option: (provided, state) => ({
    ...provided,
    // eslint-disable-next-line no-nested-ternary
    backgroundColor: state.isSelected ? '#19202d' : (state.isFocused ? '#f3f5fa' : '#fff'),
    fontSize: 18,
    fontWeight: 400,
    textTransform: 'none',
  }),
  placeholder: provided => ({
    ...provided,
    color: '#8ea3b5',
    opacity: 0.6,
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    marginTop: state.isMulti ? '' : -12,
    paddingLeft: 16,
  }),
  singleValue: provided => ({
    ...provided,
    color: '#19202d',
  }),
};

const selectorProps = {
  styles: selectorStyles,
  classNamesPrefix: 'sel',
  components: { DropdownIndicator },
};

export {
  Button,
  Container,
  FormField,
  HelpBlock,
  InputFile,
  InputText,
  Label,
  Row,
  SectionSeparator,
  SectionTitle,
  Separator,
  SuccessMessage,
  selectorProps,
  Textarea,
};
